import React, { useEffect } from 'react';
import { Flex, Select, Typography } from 'antd';
import { contactChoiceOptions, useContactChoices } from '@/components/Contacts/useContactChoices';
import { F } from '@/utils/intl';
import styles from './index.less';

type ProjectContactSelectProps = {
  customerId: string;
  /** The chosen contact's id (e.g. the one matched by email); `undefined` takes the customer's primary once loaded. */
  value?: string;
  onChange: (contactId: string) => void;
};

/**
 * The existing customer's contact who leads the new project — the customer's
 * primary unless picked otherwise. Hidden when there is nobody else to pick.
 */
const ProjectContactSelect: React.FC<ProjectContactSelectProps> = ({ customerId, value, onChange }) => {
  const { contacts, defaultId } = useContactChoices({ customerId });

  useEffect(() => {
    if (defaultId && !value) onChange(defaultId);
    // `onChange` only reports the default.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultId]);

  if (!contacts || contacts.length < 2) return null;
  return (
    <Flex vertical gap={4} className={styles.projectContact}>
      <Typography.Text strong>
        <F id="component.contacts.projectPrimary" defaultMessage="Primary contact of the project" />
      </Typography.Text>
      <Select value={value} onChange={onChange} options={contactChoiceOptions(contacts)} />
    </Flex>
  );
};

export default React.memo(ProjectContactSelect);
